import PropTypes from 'prop-types';
import Infobox from './Infobox';
import JobTile from './JobTile';

export default function JobTileGroup({ getLabel, getFilteredJobs, resetAllFilters, taxonomies }) {
	const jobs = getFilteredJobs();

	return jobs.length ? (
		<div className="jobs__tiles">
			{jobs.map((job) => (
				<JobTile key={job.id} job={job} taxonomies={taxonomies} />
			))}
		</div>
	) : (
		<Infobox getLabel={getLabel} resetAllFilters={resetAllFilters} />
	);
}

JobTileGroup.propTypes = {
	getLabel: PropTypes.func.isRequired,
	getFilteredJobs: PropTypes.func.isRequired,
	resetAllFilters: PropTypes.func.isRequired,
	taxonomies: PropTypes.object.isRequired,
};
